import React, { Component } from "react";
import { Input, Label, Alert, Hint } from "@americanexpress/dls-react";
import "./AccessApprovalStyle.css";
import { withTranslation } from "react-i18next";
import { Select, SelectOption } from "@americanexpress/dls-react";
import { AGREE, COUNTRY_NAME, yes } from "../Common/constants";
import TermsAndConditionsWrapper from "../TermsAndConditions/TermsAndConditionsWrapper";

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      submit: false,
      fninvalid: false,
      fnempty: false,
      lnempty: false,
      lninvalid: false,
      posempty: false,
      emailempty: false,
      emailinvalid: false,
      phempty: false,
      phinvalid: false,
      checkBox: [],
      users: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        emailId: "",
        position: "",
        country: [],
        agree: false,
        agreedCountries: [],
      },
      selectedCountries: [],
    };
  }

  componentDidMount() {
    const { t } = this.props;
    let users = { ...this.state.users };

    let accessCountry = this.props.AccessCountryUser.access.filter(
      (acc) => acc.country,
    );

    const accessListForAPAC = this.props.AccessCountryUser.access.filter(
      (acc) => {
        return !acc.country.includes(t("access.UNITEDKINGDOM"));
      },
    );

    const accessListForUK = this.props.AccessCountryUser.access.filter(
      (acc) => {
        return acc.country.includes(t("access.UNITEDKINGDOM"));
      },
    );

    const isUKCountryAccess =
      (this.props.AccessCountryUser.selfenroll === "1" &&
        ((accessCountry.length === 1 &&
          accessCountry[0].country === t("access.UNITEDKINGDOM")))) ||
      accessCountry.length === 0 ||
      this.props.onlyUKAccess === true;

    if (this.props.user !== undefined) {
      if (this.props.prev === "prev") {
        users.firstName = this.props.user.firstName || "";
        users.position = this.props.user.position || "";
        users.lastName = this.props.user.lastName || "";
        users.emailId = this.props.user.emailId || "";
        users.phoneNumber = this.props.user.phoneNumber || "";
        users.agree = this.props.user.agree || false;
        if (this.props.AccessCountryUser.selfenroll === "1") {
          users.country = accessListForAPAC;
        }
        if (isUKCountryAccess) {
          users.country = accessListForUK;
        }
        this.updateSavobj("agree", false);
        this.props.getUser(
          this.props.user,
          this.props.index,
          this.props.id,
          false,
        );
      } else {
        if (this.props.user.selfenroll === "1") {
          users.firstName = this.props.user.firstName;
          users.lastName = this.props.user.lastName;
          users.emailId = this.props.user.emailId;
          users.phoneNumber = this.props.user.phoneNumber;
          users.country = accessListForAPAC;
        }

        if (isUKCountryAccess) {
          users.firstName = "";
          users.lastName = "";
          users.emailId = "";
          users.phoneNumber = "";
          users.country = accessListForUK;
        }

        this.updateSavobj("agree", false);
        this.props.getUser(
          this.state.users,
          this.props.index,
          this.props.id,
          false,
        );
      }
    } else {
      if (
        this.props.user === undefined &&
        this.props.prev === "prev" &&
        this.props.AccessCountryUser.selfenroll === "1"
      ) {
        users.country = accessListForUK;
        this.updateSavobj("agree", false);
        this.props.getUser(
          this.state.users,
          this.props.index,
          this.props.id,
          false,
        );
      }
    }

    const IndividualTandCCountries = {
      [t("access.JAPAN")]: COUNTRY_NAME.JAPAN,
      [t("access.UNITEDKINGDOM")]: COUNTRY_NAME.UNITEDKINGDOM,
      [t("access.SWEDEN")]: COUNTRY_NAME.SWEDEN,
      [t("access.NORWAY")]: COUNTRY_NAME.NORWAY,
      [t("access.INTERNATIONALEUROCARD")]: COUNTRY_NAME.INTERNATIONALEUROCARD,
    };

    let selectedCountries = [
      ...new Set(
        accessCountry.map(({ country }) =>
            IndividualTandCCountries[country] ?? COUNTRY_NAME.OTHERCOUNTRIES,
        ),
      ),
    ];

    if (selectedCountries.length === 0 && this.props.AccessCountryUser?.country) {
      const enrollTC = IndividualTandCCountries[this.props.AccessCountryUser.country];
      if (enrollTC) {
        selectedCountries = [enrollTC];
      }
    }

    this.setState({
      users,
      selectedCountries: selectedCountries,
    });
  }

  validateFirstName = () => {
    if (this.state.users["firstName"] === "") {
      this.setState({ fnempty: true });
    } else {
      this.setState({ fnempty: false });
    }
    if (!this.state.users.firstName.match(/^[a-zA-Z -]*$/)) {
      this.setState({ fninvalid: true });
    } else {
      this.setState({ fninvalid: false });
    }
  };

  validateLastName = () => {
    if (this.state.users["lastName"] === "") {
      this.setState({ lnempty: true });
    } else {
      this.setState({ lnempty: false });
    }
    if (!this.state.users.lastName.match(/^[a-zA-Z -]*$/)) {
      this.setState({ lninvalid: true });
    } else {
      this.setState({ lninvalid: false });
    }
  };

  validatePhoneNo = () => {
    if (this.state.users["phoneNumber"] === "") {
      this.setState({ phempty: true });
    } else {
      this.setState({ phempty: false });
    }
    if (!this.state.users["phoneNumber"].match(/^[0-9+-]*$/)) {
      this.setState({ phinvalid: true });
    } else {
      this.setState({ phinvalid: false });
    }
  };

  validateEmail = () => {
    if (this.state.users["emailId"] === "") {
      this.setState({ emailempty: true });
    } else {
      this.setState({ emailempty: false });
    }
    if (
      !this.state.users.emailId.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/,
        // /^[a-zA-Z0-9.]+[-._a-z]+@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
      )
    ) {
      this.setState({ emailinvalid: true });
    } else {
      this.setState({ emailinvalid: false });
    }
  };

  validatePosition = () => {
    if (this.state.users["position"] === "") {
      this.setState({ posempty: true });
    } else {
      this.setState({ posempty: false });
    }
  };

  /** Checking whether user have selected all the checkbox and updating the state*/
  getCheckedBoth = (CheckBoxName, value) => {
    let checkBox = this.state.users.agreedCountries || [];
    const isAgreed = value === yes;

    const isExistingIndex = checkBox.includes(CheckBoxName);

    if (isAgreed && !isExistingIndex) {
      checkBox.push(CheckBoxName);
    } else {
      const index = checkBox.indexOf(CheckBoxName);
      if (index > -1) {
        checkBox.splice(index, 1);
      }
    }
    const isAllChecked =
      this.state.selectedCountries.length === checkBox.length;
    this.updateSavobj(AGREE, isAllChecked);
    this.setState({
      users: { ...this.state.users, agreedCountries: checkBox },
    });
  };

  /** Updating the state as selected both the check boxes*/
  getchecked = (value) => {
    if (value === "yes") {
      this.updateSavobj("agree", true);
      if (this.state.users.agree) {
        this.props.getUser(
          this.state.users,
          this.props.index,
          this.props.id,
          true,
        );
      }
    } else {
      this.updateSavobj("agree", false);
    }
  };

  updateSavobj = (key, value) => {
    let users = this.state.users;
    users[key] = value;
    this.setState({ users }, () => {
      this.props.getUser(
        this.state.users,
        this.props.index,
        this.props.id,
        true,
      );
    });
  };

  render() {
    const { t } = this.props;

    return (
      <>
        <div className="row">
          {this.props.approverCount > 1 && (
            <div className="col-12 pad-2-tb">
              <Label>{`${t("access.approver")} - ${this.props.id + 1} :`}</Label>
            </div>
          )}
          {this.props.i18n.language === "en" ? (
            <>
              <div className="col-sm-4 pad-2-b">
                <Label>{t("newuser.fn")}</Label>
                <Input
                  value={this.state.users?.firstName}
                  onChange={(event) => {
                    this.updateSavobj("firstName", event.target.value);
                  }}
                  onBlur={this.validateFirstName}
                />

                {(this.state.fnempty ||
                  (this.props.submit &&
                    this.state.users?.firstName?.trim() === "")) && (
                  <Alert status="error">{t("newuser.fnrequired")}</Alert>
                )}
                {this.state.fninvalid && this.props.i18n.language === "en" && (
                  <Alert status="error">{t("newuser.fnerror")}</Alert>
                )}
              </div>

              <div className="col-sm-4 pad-2-b">
                <Label>{t("newuser.ln")}</Label>
                <Input
                  value={this.state.users?.lastName}
                  onChange={(event) => {
                    this.updateSavobj("lastName", event.target.value);
                  }}
                  onBlur={this.validateLastName}
                />

                {(this.state.lnempty ||
                  (this.props.submit &&
                    this.state.users?.lastName?.trim() === "")) && (
                  <Alert status="error">{t("newuser.lnrequired")}</Alert>
                )}
                {this.state.lninvalid && this.props.i18n.language === "en" && (
                  <Alert status="error">{t("newuser.lnerror")} </Alert>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="col-sm-4 pad-2-b">
                <Label>{t("newuser.ln")}</Label>
                <Input
                  value={this.state.users?.lastName}
                  onChange={(event) => {
                    this.updateSavobj("lastName", event.target.value);
                  }}
                  onBlur={this.validateLastName}
                />

                {(this.state.lnempty ||
                  (this.props.submit &&
                    this.state.users?.lastName?.trim() === "")) && (
                  <Alert status="error">{t("newuser.lnrequired")}</Alert>
                )}
                {this.state.lninvalid && this.props.i18n.language === "en" && (
                  <Alert status="error">{t("newuser.lnerror")} </Alert>
                )}
              </div>

              <div className="col-sm-4 pad-2-b">
                <Label>{t("newuser.fn")}</Label>
                <Input
                  value={this.state.users?.firstName}
                  onChange={(event) => {
                    this.updateSavobj("firstName", event.target.value);
                  }}
                  onBlur={this.validateFirstName}
                />

                {(this.state.fnempty ||
                  (this.props.submit &&
                    this.state.users?.firstName?.trim() === "")) && (
                  <Alert status="error">{t("newuser.fnrequired")}</Alert>
                )}
                {this.state.fninvalid && this.props.i18n.language === "en" && (
                  <Alert status="error">{t("newuser.fnerror")}</Alert>
                )}
              </div>
            </>
          )}

          <div className="col-sm-4 pad-2-b">
            <div className="positionField">
              <Label htmlFor="select-1">{t("newuser.position")}</Label>
              <Select
                id="select-1"
                value={this.state.users?.position}
                onChange={(event) => {
                  this.updateSavobj("position", event.target.value);
                }}
                onBlur={this.validatePosition}
              >
                <SelectOption value="" />
                {this.props.i18n.language === "en" ? (
                  <>
                    <SelectOption value="Program Administrator">
                      Program Administrator
                    </SelectOption>
                    <SelectOption value="Authorized Signatory">
                      Authorized Signatory
                    </SelectOption>
                  </>
                ) : (
                  <>
                    <SelectOption value="Program Administrator">
                      {t("newuser.position1")}
                    </SelectOption>
                    <SelectOption value="Master Program Administrator">
                      {t("newuser.position2")}
                    </SelectOption>
                    <SelectOption value="Decision Maker">
                      {t("newuser.position3")}
                    </SelectOption>
                    <SelectOption value="Authorised Signatory">
                      {t("newuser.position4")}
                    </SelectOption>
                    <SelectOption value="Authorising Officer">
                      {t("newuser.position5")}
                    </SelectOption>
                  </>
                )}
              </Select>

              {(this.state.posempty ||
                (this.props.submit && this.state.users.position === "")) && (
                <Alert status="error">{t("newuser.rolerequired")}</Alert>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-8 pad-1-b">
            <Label className="label-3">
              {this.props.country === t("access.UNITEDKINGDOM")
                ? t("newUserUK.email")
                : t("newuser.email")}
            </Label>
            <Input
              value={this.state.users?.emailId}
              onChange={(event) => {
                this.updateSavobj("emailId", event.target.value);
              }}
              onBlur={this.validateEmail}
            />
            {(this.state.emailempty ||
              (this.props.submit &&
                this.state.users?.emailId?.trim() === "")) && (
              <Alert status="error">{t("newuser.emailrequired")}</Alert>
            )}
            {this.state.emailinvalid && this.props.i18n.language === "en" && (
              <Alert status="error">{t("newuser.emailerror")}</Alert>
            )}
          </div>

          <div className="col-sm-4 pad-1-b">
            <Label className="label-3">
              {this.props.country === t("access.UNITEDKINGDOM")
                ? t("newUserUK.companyTelphoneNumber")
                : t("newuser.phno")}
            </Label>
            <Input
              value={this.state.users?.phoneNumber}
              onChange={(event) => {
                this.updateSavobj("phoneNumber", event.target.value);
              }}
              onBlur={this.validatePhoneNo}
            />
            <Hint>{t("common.TelephoneInfoMessage")}</Hint>

            {(this.state.phempty ||
              (this.props.submit &&
                this.state.users?.phoneNumber?.trim() === "")) && (
              <Alert status="error">{t("newuser.phnrequired")}</Alert>
            )}
            {this.state.phinvalid && (
              <Alert status="error">{t("newuser.phnerror")} </Alert>
            )}
          </div>
        </div>

        {this.state.users.firstName !== "" &&
          this.state.users.lastName !== "" &&
          this.state.users.position !== "" &&
          this.state.users.emailId !== "" &&
          this.state.users.phoneNumber !== "" && (
            <div className="row pad-2-b">
              <div className="col-sm-12">
                {this.state.selectedCountries &&
                    <TermsAndConditionsWrapper
                      selectedCountries={this.state.selectedCountries}
                      getChecked={(value, countryLabel) => {
                        this.getCheckedBoth(countryLabel, value);
                      }}
                      agree={this.state.users.agree}
                      lang={this.props.i18n.language}
                      selfenroll={this.props.AccessCountryUser.selfenroll}
                    />
                  }
              </div>
            </div>
          )}
      </>
    );
  }
}

export default withTranslation("common")(Form);
